'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const GdprConsentLayer = ({
  gaPropertyId,
  consentText
}) => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const userConsent = localStorage.getItem('gdpr-consent');
    if (userConsent === null) {
      setIsVisible(true);
    } else if (userConsent === 'accepted') {
      consentCallback();
    }
  }, []);
  const consentCallback = () => {
    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${gaPropertyId}`;
    document.head.appendChild(scriptElement);
    scriptElement.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', gaPropertyId);
    };
  };
  const handleAccept = () => {
    localStorage.setItem('gdpr-consent', 'accepted');
    setIsVisible(false);
    consentCallback();
  };
  const handleDeny = () => {
    localStorage.setItem('gdpr-consent', 'denied');
    setIsVisible(false);
  };
  return _react.default.createElement(_styles.ConsentLayer, {
    isVisible: isVisible
  }, _react.default.createElement(_styles.ConsentText, null, consentText), _react.default.createElement(_styles.ConsentActions, null, _react.default.createElement(_styles.ConsentButtonAlternative, {
    id: "gdpr-consent-layer-deny",
    onClick: handleDeny
  }, "Deny"), _react.default.createElement(_styles.ConsentButton, {
    id: "gdpr-consent-layer-accept",
    onClick: handleAccept
  }, "Accept")));
};
var _default = GdprConsentLayer;
exports.default = _default;
//# sourceMappingURL=index.js.map